import { SvgIconType } from './svg.interface';

const Document: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#6A7383'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.25 3.75V0H3C2.17157 0 1.5 0.671573 1.5 1.5V10.5C1.5 11.3284 2.17157 12 3 12H9C9.82843 12 10.5 11.3284 10.5 10.5V5.25H6.75C5.92157 5.25 5.25 4.57843 5.25 3.75Z"
      fill={color}
    />
    <path d="M10.5 3.75L6.75 0V3.75H10.5Z" fill={color} />
  </svg>
);

export default Document;
